import React from "react"
import Locator from './src/providers/locator'

export default ({ element }) => {
  return <Locator>{element}</Locator>;
}
